import {WorkspaceObj} from 'common/report/queries/app-api/workspaces-client';

export enum WorkspaceStatus {
  NO_WORKSPACE_ACCESS = `NO_WORKSPACE_ACCESS`,
  HAS_GLOBAL_WORKSPACE_ACCESS = `HAS_GLOBAL_WORKSPACE_ACCESS`,
  LOADING = `LOADING`,
  LOADING_WORKSPACE = `LOADING_WORKSPACE`,
  PROJECT = `PROJECT`,
  GLOBAL_WORKSPACE = `GLOBAL_WORKSPACE`,
}

export interface WorkspaceGlobalOnlyBannerState {
  workspaceStatus: WorkspaceStatus;
  globalProjectWorkspace: WorkspaceObj | {name: string; id: number};
  projectId: number;
}

export interface WorkspaceGlobalOnlyBannerAttrs {
  'workspace-id': number;
  'app-name': string;
}
